import { ReactComponent as AudioFile } from '@public/icons/audio-file.svg';
import Icon from '../atoms/Icon';

const IconAudioFile = (props) => <Icon as={AudioFile} {...props} />;

IconAudioFile.propTypes = Icon.propTypes;

export default IconAudioFile;
